import React from 'react';
import { ProgressBar as BSProgressBar } from 'react-bootstrap';
import './ProgressBar.scss';

export interface ProgressBarProps {
    percent: number;
    message?: string;
    error?: boolean;
    className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = (props) => {

    let msg = props.message;
    let pct = props.percent || 0;
    if (Number.isNaN(pct)) {
        pct = 0;
    }
    let pctDisplay = pct.toFixed(0) + '%';
    if (!props.percent) {
        pctDisplay = '';
    }

    let barColor = 'default';
    if (props.error) {
        barColor = 'danger';
    } else if (props.percent >= 100) {
        barColor = 'success';
    }

    const cssClasses = `${props.className || ''}`

    return (
        <div className="progress-bar-container">
            <div className="progress-msg-wrapper">
                <div>{msg}</div>
            </div>
            <BSProgressBar now={props.percent || 0} label={<span>{pctDisplay}</span>} bsStyle={barColor} className={cssClasses} />
        </div>
    )
}

(ProgressBar as any).displayName = "ProgressBar"